<ul class="nav nav-pill shadow flex-column bg-white">
    <li *ngIf="isLoggedIn() && isInRole('user')" class="nav-item mt-xl-9">
        <a class="nav-link position-relative p-0 py-xl-3 px-xl-4" [routerLink]="['/profile/contact']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            Contact Detail
        </a>
    </li>
    <!-- <li *ngIf="isLoggedIn() && isInRole('user')" class="nav-item mt-xl-9">
        <a class="nav-link position-relative p-0 py-xl-3 px-xl-4" [routerLink]="['/profile/account']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            Edit Account
        </a>
    </li> -->
    <li class="nav-item mt-xl-9">
        <a class="nav-link position-relative p-0 py-xl-3 px-xl-4" [routerLink]="['/profile/change-password']"
            routerLinkActive="border-2 bg-light border-secondary border-left">
            Change Password
        </a>
    </li>
</ul>
